/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-runloop, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { scheduleOnce } from '@ember/runloop';

// D3 imports
import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';
import { create } from 'd3-selection';
export default class ChartGroupedBarLegend extends Component {
  @tracked
  legend = null;
  data = [];

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    // Schedule a call to our `draw` method on Ember's "render" queue, which will
    // happen after the component has been placed in the DOM, and subsequently
    // each time data is changed.
    scheduleOnce('render', this, this.draw);
  }

  draw() {
    let timeframes = new Set(this.data.map((d) => d.timeframe));
    let color = scaleOrdinal()
      .domain(Array.from(timeframes))
      .range(schemeCategory10);

    let legendSvg = create('svg').attr('width', 500).attr('height', 100);
    let legend = legendSvg
      .append('g')
      .attr('class', 'legend')
      .attr('transform', `translate(50, 3)`);

    // Define the width of each legend item and the number of items per row
    let itemWidth = 150;
    let itemsPerRow = Math.floor(500 / itemWidth);

    // Add legend items in multiple rows
    let legendItems = legend
      .selectAll('.legend-item')
      .data(Array.from(timeframes))
      .enter()
      .append('g')
      .attr('class', 'legend-item')
      .attr(
        'transform',
        (d, i) =>
          `translate(${(i % itemsPerRow) * itemWidth}, ${
            Math.floor(i / itemsPerRow) * 20
          })`,
      );

    // Add colored rectangles
    legendItems
      .append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', 10)
      .attr('height', 10)
      .attr('fill', (d) => color(d));

    // Add text labels
    legendItems
      .append('text')
      .attr('x', 15)
      .attr('y', 10)
      .text((d) => d);

    this.legend = Object.assign(legendSvg.node());
  }
}
